/*
 * Package: WebVideo.ManagerPerson
 * Version: $Id$
 * Copyright (c) 2011 Sergey Leonov
 */

function ManagerPerson() {}

ManagerPerson.FIELD_CUSTOM_PREFIX = "manager_custom_";

ManagerPerson.getFBConnectionUrl = function (login_redirect_url) {
  var _url = Config.manager + "/login/facebook";
  _url += "?" + ManagerPerson.FIELD_CUSTOM_PREFIX + "time_zone=" + TimeUtils.getTzNameByLocation(Config.location, Config.defaultTimezone);
  if (login_redirect_url != null) {
    _url += "&login_redirect_url=" + encodeURI(login_redirect_url);
  }
  return _url;
};

ManagerPerson.initFBLogin = function (login_redirect_url) {
  FB.login(function(response) {
    if (response.status == 'connected') {
      document.location.href = ManagerPerson.getFBConnectionUrl(login_redirect_url);
    }
  }, {perms:'email,user_birthday,user_about_me,user_photos'});
};

ManagerPerson.submitJoinForm = function (form) {
  form.elements[ManagerPerson.FIELD_CUSTOM_PREFIX + "time_zone"].value = TimeUtils.getTzNameByLocation(Config.location, Config.defaultTimezone);
  return true;
};